<template>
    <!-- begin panel -->
    <!--
    <panel no-button="true" v-if="storyboard" v-bind:title="storyboard.name ? storyboard.name : ''">
    </panel>
    -->
    <!-- end panel -->
    <router-view 
        v-bind:storyboard="storyboard" 
        v-bind:storyboards="storyboards" 
        v-bind:stage="stage" 
        v-bind:stages="stages" 
        v-bind:step="step" 
        v-bind:steps="steps" 
        v-bind:scriptItems="scriptItems"
        v-bind:activeEvent="activeEvent"
        v-bind:getStep="getStep"
        v-bind:removeImage="removeImage"
        v-bind:removeFile="removeFile"
        v-bind:deleteNoteCall="deleteNoteCall"
        v-bind:bulkDeleteStoryboards="bulkDeleteStoryboards"
        v-bind:bulkDeleteStages="bulkDeleteStages"
        v-bind:bulkDeleteSteps="bulkDeleteSteps"
        v-bind:bulkSetStageStoryboards="bulkSetStageStoryboards"
        v-bind:bulkSetStepStages="bulkSetStepStages"
    />
</template>

<script>
export default {
    name: 'StoryboardPanel',
    props: [
        'storyboard', 
        'storyboards', 
        'stage', 
        'stages', 
        'step', 
        'steps', 
        'scriptItems', 
        'activeEvent', 
        'getStep', 
        'removeImage',
        'removeFile',
        'deleteNoteCall',
        'bulkDeleteStoryboards',
        'bulkDeleteStages',
        'bulkDeleteSteps',
        'bulkSetStageStoryboards',
        'bulkSetStepStages',
    ]
}
</script>